import { ref, toRaw } from 'vue';

import { message } from 'ant-design-vue';

import { useRouter } from 'vue-router';

import Api from '@/api/Api';

import camelCase from 'lodash/camelCase';

import { useBaselinesStore } from '@/stores/baselinesStore';
import { useSessionStore } from '@/stores/session';

import { showErrorMessage, getErrorText } from '@/components/common/errorMessage';


export function useFormSubmit(
	validate,
	baselineId,
	formState,
	validateInfos,
	messages,
	resetChangedState,
	onSuccessHook = null,
	onErrorHook = null,
) {
	const isSubmitting = ref(false);
	const router = useRouter();
	const baselinesStore = useBaselinesStore();
	const sessionStore = useSessionStore();
	const onSubmit = closeFormAfterSuccess => {
		validate().then(() => {
			isSubmitting.value = true;
			const data = Api.serializeBaselineAdd(toRaw(formState), baselineId.value);
			const submitRequest = baselineId.value > 0 ? Api.baselineEdit : Api.baselineAdd;
			submitRequest(data, response => {
				if (response.status === 'ok') {
					message.success(messages.value.successMessage);
					baselinesStore.refresh();
					if (closeFormAfterSuccess) {
						router.push({ name: sessionStore.closeButtonRoute || 'baselines' });
					}
					resetChangedState();
					if (!closeFormAfterSuccess && onSuccessHook != null) {
						onSuccessHook();
					}
				} else {
					['base', 'rover', 'selected_gnss'].forEach(element => {
						if (response.errors[element]) {
							let jsElement = camelCase(element);
							validateInfos[jsElement].validateStatus = 'error';
							validateInfos[jsElement].help = getErrorText(element, response.errors[element]);
						}
					});
					showErrorMessage(response.errors);
					if (onErrorHook != null) {
						onErrorHook(false);
					}
				}
				isSubmitting.value = false;
			});
		}).catch(err => {
			console.log('error', err);
			if (onErrorHook != null) {
				onErrorHook(true);
			}
		});
	};
	return {
		isSubmitting,
		onSubmit,
	}
} 